import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Clock } from '@phosphor-icons/react';

const MemoriesSection = ({ memories }) => {
  if (!memories || memories.length === 0) return null;

  return (
    <div className="mb-8" data-testid="memories-section">
      <div className="flex items-center gap-2 mb-4">
        <Clock weight="duotone" className="w-5 h-5 text-[#C4A35A]" />
        <h2 className="font-heading text-xl font-semibold text-[#1A1918]">This Time Last Year</h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {memories.map((mem, idx) => {
          const photos = (mem.visit?.attachments || []).filter(a => a.file_path);
          const photoUrl = photos.length > 0
            ? `${process.env.REACT_APP_BACKEND_URL}/api${photos[0].file_path}`
            : null;
          return (
            <Link
              key={`${mem.visit?.id}-${idx}`}
              to={`/restaurants/${mem.restaurant_id}`}
              className="card-elevated overflow-hidden hover:shadow-lg transition-shadow"
              data-testid={`memory-${idx}`}
            >
              {photoUrl ? (
                <div className="h-32 relative">
                  <img src={photoUrl} alt="" className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                  <div className="absolute top-2 left-3 bg-[#C4A35A] text-white text-xs font-semibold rounded-full px-2.5 py-1">
                    {mem.years_ago} year{mem.years_ago > 1 ? 's' : ''} ago
                  </div>
                </div>
              ) : (
                <div className="h-20 bg-gradient-to-r from-[#C4A35A]/10 to-[#A94438]/10 flex items-center justify-center">
                  <span className="text-xs font-semibold text-[#C4A35A]">{mem.years_ago} year{mem.years_ago > 1 ? 's' : ''} ago</span>
                </div>
              )}
              <div className="p-3">
                <h3 className="font-semibold text-[#1A1918] text-sm">{mem.restaurant_name}</h3>
                {mem.restaurant_suburb && (
                  <p className="text-xs text-[#7A7873] flex items-center gap-1">
                    <MapPin weight="fill" className="w-3 h-3" />{mem.restaurant_suburb}
                  </p>
                )}
                {(mem.visit?.notes || mem.visit?.journal_entry) && (
                  <p className="text-xs text-[#7A7873] mt-1 line-clamp-1 italic">
                    "{mem.visit.journal_entry || mem.visit.notes}"
                  </p>
                )}
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default MemoriesSection;
